export const SoldSticker = ({ size = "sm", testId }) => (
  <div data-testid={testId} className="pointer-events-none absolute inset-0 grid place-items-center overflow-hidden bg-[#0f2a33]/35">
    <div className={`-rotate-[14deg] rounded-xl border-[3px] border-[#0f2a33] bg-[#d4f253] font-display font-extrabold uppercase tracking-tight text-[#0f2a33] shadow-[0_8px_24px_rgba(0,0,0,0.35)] ${size === "lg" ? "px-10 py-4 text-5xl sm:text-6xl" : "px-5 py-2 text-2xl"}`}>
      ISoldIt<span className="text-[#0f2a33]/60">!</span>
    </div>
  </div>
);
